import { priceDateKey } from './priceDateKey';
import { addMonths, eachDayOfInterval, isAfter, startOfToday } from 'date-fns';

export type PricingWindow = { start: Date; end: Date };

// Les prix sont calculés jour par jour dans le navigateur : on calcule d'emblée
// cette fenêtre, puis on l'étend tranche par tranche quand l'utilisateur avance
// dans le calendrier (voir useCircuitPrices).
export const INITIAL_PRICING_WINDOW_IN_MONTHS = 11;

// Plafond de sécurité : il borne les boucles jour par jour si une période de
// tarif est saisie très loin dans le futur (ex. jusqu'en 2099).
export const MAX_PRICING_HORIZON_IN_MONTHS = 36;

export const getDefaultPricingWindow = (
  today = startOfToday(),
): PricingWindow => ({
  start: today,
  end: addMonths(today, INITIAL_PRICING_WINDOW_IN_MONTHS),
});

export const getMaxPricingDate = (today = startOfToday()) =>
  addMonths(today, MAX_PRICING_HORIZON_IN_MONTHS);

export const getPricingStartDates = (
  until: Date = getDefaultPricingWindow().end,
) => {
  const today = startOfToday();
  if (isAfter(today, until)) return [];
  return eachDayOfInterval({ start: today, end: until });
};

export const getDatesToPrice = (targetDates?: Date[], until?: Date): Date[] => {
  const startDates = getPricingStartDates(until);
  if (!targetDates?.length) return startDates;
  const startDatesSet = new Set(startDates.map((d) => priceDateKey(d)));
  const extra = targetDates.filter((d) => !startDatesSet.has(priceDateKey(d)));
  return [...startDates, ...extra];
};
